import { Updater, AsyncState, unloadedAsyncState, loadingAsyncState } from 'widgets-for-react'
import { createItem, loadItems } from './date.api'

export interface ItemWithDates {
  id: string,
  createdDate: Date
  modifiedDate: Date
  dateTest: Date
}


export interface DateTestState {
  items: AsyncState<ItemWithDates[]>,
  save: AsyncState<void>,
  input: string
}
export const initialDateTestState: DateTestState = {
  items: unloadedAsyncState(),
  save: unloadedAsyncState(),
  input: ""
}

export const DateStateUpdaters = {
  updateDate : (text: string): Updater<DateTestState> =>
    dateState => ({
      ...dateState,
      input: text
    }),
  saveAndReload: (date: Date): Updater<DateTestState> =>
    dateState => ({
      ...dateState,
      save: loadingAsyncState(() => createItem(date)),
      items: unloadedAsyncState(),
      input: ""
    })
}